import { AllowedComponentsContainer } from '@adobe/aem-react-editable-components';

import ConditionsSearch from '@/features/ConditionsSearch';

class IntegrationConditionsSearch extends AllowedComponentsContainer {
    /**
     * Overriding the @aem-react-editable-components method to pass in
     * 'aemNoDecoration={true}' property to suppress wrapper divs
     * aem-react-editable-components/src/components/Container.tsx
     */
    connectComponentWithItem(ChildComponent, itemProps, itemKey) {
        const itemPath = this.getItemPath(itemKey);

        return (
            <ChildComponent
                {...itemProps}
                key={itemPath}
                cqPath={itemPath}
                aemNoDecoration={true}
                isInEditor={this.props.isInEditor}
                containerProps={this.getItemComponentProps(itemProps, itemKey, itemPath)}
            />
        );
    }

    render() {
        return (
            <ConditionsSearch
                heroContainer={this.childComponents[0]}
                leftContainer={this.childComponents[1]}
                rightContainer={this.childComponents[2]}
            />
        );
    }
}
export default IntegrationConditionsSearch;
